// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"subscription_wrapper__abuWk","title":"subscription_title__brdMO","table":"subscription_table__aBPqi"};